const SuccessPage = () => {
    return (
        <div className="d-flex justify-content-center align-items-center w-100" style={{ height: "100vh" }}>
            <h3>Submit button is clicked</h3>
        </div> 
    );
};

export default SuccessPage;
